
import PropTypes from 'prop-types'
import MenuV5 from '@mui/material/Menu'
import { MenuItemView } from './popover/MenuItemView'

import { constants as fromRequestReliefVehicles } from 'features/request-relief-vehicles'
import { constants as fromRequestVehicleRelocations } from 'features/request-vehicle-relocations'
import { constants as fromRequestVehicleSummary } from 'features/request-vehicle-summary'
import { constants as fromRequestRucSummary } from 'features/request-ruc-summary'
import { useHasRucAccess } from 'features/settings'

import { useLocation } from 'react-router-dom'

const ActionsPopover = ({ anchor, linker, open, onClose }) => {
  const location = useLocation()
  const hasRucAccess = useHasRucAccess()

  if ( ! anchor.current) {
    return null
  }

  return (
    <MenuV5
      id="menu-reports"
      anchorEl={anchor.current}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            '& ul': {
              padding: 0,
            }
          }
        },
      }}>
      <div>
        <MenuItemView
          onClick={linker(fromRequestReliefVehicles.PATH_ADD)}
          title="Request Relief/Rental Vehicle"
          isActive={fromRequestReliefVehicles.PATH_ADD === location.pathname}
          isVisible={true}/>
        <MenuItemView
          onClick={linker(fromRequestVehicleRelocations.PATH_ADD)}
          title="Request Vehicle Relocation"
          isActive={fromRequestVehicleRelocations.PATH_ADD === location.pathname}
          isVisible={true}/>

        <MenuItemView
          onClick={linker(fromRequestVehicleSummary.PATH_ADD)}
          title="Request Vehicle Order"
          isActive={fromRequestVehicleSummary.PATH_ADD === location.pathname}
          isVisible={true}/>

        <MenuItemView
          onClick={linker(fromRequestRucSummary.PATH_ADD)}
          title="Request RUC Order"
          isActive={fromRequestRucSummary.PATH_ADD === location.pathname}
          isVisible={hasRucAccess}/>

      </div>
    </MenuV5>
  )
}

ActionsPopover.propTypes = {
  anchor: PropTypes.object,
  linker: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default ActionsPopover
